import React, { useState, useCallback } from "react";
import styled from "styled-components";
import StyleConfig from "src/constants/StyleConfig";
import HeaderBar from "src/components/organisms/header/HeaderBar";
import { ChildrenProps, DefaultPageProps } from "src/constants/Interface";
import Menu from "src/components/organisms/menu/NavMenu";

type Props = ChildrenProps & DefaultPageProps;

const DefaultLayout = ({ ...props }: Props) => {
  const [isMenuOpen, toggleMenuOpen] = useState(false);

  const onLogout = () => {
    props.handleLogOut();
  };

  const wrapToggleMenuOpen = useCallback(
    (v: boolean) => {
      toggleMenuOpen(v);
    },
    [toggleMenuOpen]
  );

  return (
    <Wrapper>
      <div id="menu" className="menu">
        <HeaderBar
          goBackAction={() => {
            props.goBackUrl();
          }}
          logoClickAction={() => {
            props.pushUrl("/");
          }}
          isMenuOpen={isMenuOpen}
          toggleMenuOpen={wrapToggleMenuOpen}
        />
        <Menu
          isMenuOpen={isMenuOpen}
          handleLogOut={onLogout}
          user={props.user}
          login_shop_id={props.login_shop_id}
        />
      </div>
      <div className="inner">{props.children}</div>
    </Wrapper>
  );
};

const NoHeaderLayout = ({ ...props }: ChildrenProps) => {
  return (
    <Wrapper>
      <div className="inner no-header">{props.children}</div>
    </Wrapper>
  );
};

const Wrapper = styled.div`
  position: relative;
  background-color: ${StyleConfig.COLOR.ECRU};
  width: 100%;
  height: 100%;
  min-height: 100vh;
  margin: auto;
  overflow: hidden;
  .menu {
    position: relative;
    width: 100%;
  }
  > .inner {
    position: relative;
    max-width: ${StyleConfig.SETTING.maxWidth}px;
    margin: 110px auto 0;
    overflow: hidden;
    &.no-header {
      margin-top: 0;
    }
  }
`;
export { DefaultLayout, NoHeaderLayout };
export default DefaultLayout;
